
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useRef, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { useMembership, setMembership } from "../../redux/membership";
import { BASIC_TIER, REGULAR_TIER, UNLIMITED_TIER, FREE_TIER, } from "@chesshotel/constants";
import { Button } from "../../components/ui/button";
import styles from "./Memberships.module.css";
import { FaAward, FaCheck } from "react-icons/fa";
import { SiBitcoin } from "react-icons/si";
import { gaEvent } from "../../lib/ga";
import Head from "next/head";
import Router, { useRouter } from "next/router";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import Script from "next/script";
import { useUser } from "../../redux/user";
import { useMetrica } from "@/lib/next-yandex-metrica";
import RegisterPopup from "@/modules/register/RegisterPopup";
const host = process.env.NEXT_PUBLIC_HOST;
export const STRIPE_PUBLISHABLE_KEY = host === "www.chesshotel.com"
    ? "pk_live_qeEylFbhs0L00dSjfkv38sbQ"
    : "pk_test_NHIqO56sCnPR51BfuTa1dtm6";
const Check = () => (<div className={styles.check}>
    <div className="flex justify-center items-center w-5 h-5 rounded-full bg-checkBg">
      <div className="flex items-center justify-center text-check w-2.5 h-2.5">
        <FaCheck />
      </div>
    </div>
  </div>);
function redirectToCheckout(sessionId) {
    if (window.Stripe) {
        const stripe = window.Stripe(STRIPE_PUBLISHABLE_KEY);
        stripe
            .redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
            sessionId,
        })
            .then((result) => {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            alert(result.error.message);
        });
    }
    else {
        setTimeout(() => {
            redirectToCheckout(sessionId);
        }, 1000);
    }
}
export function selectPlan(tier) {
    setLoadingBar(true);
    const locale = Router.locale;
    api
        .post("/stripe/session", { tier, locale })
        .then((result) => {
        setLoadingBar(false);
        redirectToCheckout(result.data.sessionId);
        // gaEvent("Memberships", "Memberships", tier);
    })
        .catch(() => {
        setLoadingBar(false);
    });
}
export function changePlan(tier) {
    setLoadingBar(true);
    const locale = Router.locale;
    api
        .post("/stripe/change", { tier, locale })
        .then((response) => {
        setLoadingBar(false);
        const { membership } = response.data;
        setMembership(membership);
        Router.push("/membership-done");
    })
        .catch((e) => {
        setLoadingBar(false);
    });
}
enum PaymentMethod {
    ALL = "all",
    CRYPTO = "crypto",
    STRIPE = "stripe"
}
function getPaymentMethod(geo: string): PaymentMethod {
    if (geo === "RU") {
        return PaymentMethod.CRYPTO;
    }
    else if (geo === "UA" || geo === "BY" || geo === "KZ") {
        return PaymentMethod.ALL;
    }
    return PaymentMethod.STRIPE;
}
export function selectPlanNowPayments(tier) {
    setLoadingBar(true);
    const locale = Router.locale;
    api
        .post("/now-payments/invoice", { tier, locale })
        .then((result) => {
        setLoadingBar(false);
        const { invoiceUrl } = result.data;
        if (invoiceUrl) {
            window.location.href = invoiceUrl;
        }
    })
        .catch(() => {
        setLoadingBar(false);
    });
}
export function selectPlanCryptomus(tier) {
    setLoadingBar(true);
    const locale = Router.locale;
    api
        .post("/cryptomus/invoice", { tier, locale })
        .then((result) => {
        setLoadingBar(false);
        const { invoiceUrl } = result.data;
        if (invoiceUrl) {
            window.location.href = invoiceUrl;
        }
    })
        .catch(() => {
        setLoadingBar(false);
    });
}
export default function Memberships() {
    const { t } = useTranslation("common");
    const { t: authT } = useTranslation("auth");
    const router = useRouter();
    const { tier, products } = useMembership();
    const { memberLoggedIn, geo } = useUser();
    const paymentMethod = getPaymentMethod(geo);
    const { reachGoal } = useMetrica();
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const guestSelectedPlan = useRef<number | null>(null);
    let basicPrice, regularPrice, unlimitedPrice;
    let buttonText;
    basicPrice = products[BASIC_TIER][router.locale] || "$2.99";
    regularPrice = products[REGULAR_TIER][router.locale] || "$3.99";
    unlimitedPrice = products[UNLIMITED_TIER][router.locale] || "$7.99";
    buttonText =
        tier === FREE_TIER ? t("Start free trial") : authT("Change membership");
    const handlePlanClick = (plan) => {
        if (!memberLoggedIn) {
            guestSelectedPlan.current = plan;
            setShowRegisterPopup(true);
            return;
        }
        gaEvent({
            category: "Memberships",
            action: "ClickOnPlan",
            label: "plan: " + plan,
        });
        reachGoal("membership_step_memberships_page_click");
        if (tier === FREE_TIER) {
            selectPlan(plan);
        }
        else {
            changePlan(plan);
        }
    };
    const handleCryptoPlanClick = (plan) => {
        if (!memberLoggedIn) {
            router.push("/signIn");
            return;
        }
        gaEvent({
            category: "Memberships",
            action: "ClickOnCryptoPlan",
            label: "plan: " + plan,
        });
        reachGoal("membership_crypto_click");
        selectPlanCryptomus(plan);
    };
    function getButtons(plan: number) {
        return (<Button size="lg" className="font-bold" onClick={() => handlePlanClick(plan)}>
        {buttonText}
      </Button>);
        if (paymentMethod === PaymentMethod.STRIPE) {
            return (<Button size="lg" className="font-bold" onClick={() => handlePlanClick(plan)}>
          {buttonText}
        </Button>);
        }
        else if (paymentMethod === PaymentMethod.CRYPTO) {
            return (<Button size="lg" className="space-x-2" onClick={() => handleCryptoPlanClick(plan)}>
          <SiBitcoin className={styles.cryptoIcon}/>
          <span>{t("Crypto / Local")}</span>
        </Button>);
        }
        else
            return (<>
          <Button size="lg" onClick={() => handlePlanClick(plan)}>
            {buttonText}
          </Button>
          <Button size="lg" variant="secondary" className="space-x-2" onClick={() => handleCryptoPlanClick(plan)}>
            <SiBitcoin className={styles.cryptoIcon}/>
            <span>{t("Crypto / Local")}</span>
          </Button>
        </>);
    }
    return (<div className={styles.bg}>
      <Script strategy="lazyOnload" src="https://js.stripe.com/v3/"/>
      <Head>
        <title>{"Chess Hotel | " + t("Premium memberships")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className="flex items-center space-x-1">
            <div className="text-orange-400">
              <FaAward />
            </div>
            <div>{t("Premium memberships")}</div>
          </div>
        </div>
        <div className={styles.tiersCont}>
          <div className={styles.tier}>
            <div className={styles.basicHeader}>BASIC</div>
            <div className={styles.tierBody}>
              <div className={styles.tierTitle}>
                {t("%price Monthly", { price: basicPrice })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("%nr league games per day", { nr: 10 })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("%nr game reviews per day", { nr: 5 })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Last %nr months database of played games", { nr: 6 })}
              </div>
              <div className={styles.buttonsCont}>{getButtons(BASIC_TIER)}</div>
            </div>
          </div>
          <div className={styles.tier}>
            <div className={styles.regularHeader}>REGULAR</div>
            <div className={styles.tierBody}>
              <div className={styles.tierTitle}>
                {t("%price Monthly", { price: regularPrice })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("%nr league games per day", { nr: 20 })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("%nr game reviews per day", { nr: 10 })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Last %nr months database of played games", { nr: 12 })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Ad free")}
              </div>
              <div className={styles.buttonsCont}>
                {getButtons(REGULAR_TIER)}
              </div>
            </div>
          </div>
          <div className={styles.tier}>
            <div className={styles.unlimitedHeader}>UNLIMITED</div>
            <div className={styles.tierBody}>
              <div className={styles.tierTitle}>
                {t("%price Monthly", { price: unlimitedPrice })}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Unlimited league games")}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Unlimited game analysis")}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Database of all games ever played")}
              </div>
              <div className={styles.basicItem}>
                <Check />
                {t("Ad free")}
              </div>
              <div className={styles.buttonsCont}>
                {getButtons(UNLIMITED_TIER)}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.header2}>
          {t("Get a premium membership and improve your game!")}
        </div>
        <div className={styles.freeTrial}>
          {t("All memberships starts with a 7 day free trial")}
        </div>
      </div>
      {showRegisterPopup && (<RegisterPopup onClose={() => {
                setShowRegisterPopup(false);
            }} redirectAfterDone={() => {
                selectPlan(guestSelectedPlan.current);
                setShowRegisterPopup(false);
            }}/>)}
    </div>);
}

    async function __Next_Translate__getStaticProps__19c7a95ed50__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/memberships/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19c7a95ed50__ as getStaticProps }
  